import React, { useEffect, useRef } from "react";
import Navbar from '../Components/Navbar';
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';
import SmartAi from "../Components/SmartAi";
import Footer from "../Components/Footer";
import Typed from "typed.js";
import { motion } from "motion/react"; // ✅ motion import
import Core from "../Components/Core";

const AboutUs = () => {
  const typedEl = useRef(null);

  useEffect(() => {
    const typed = new Typed(typedEl.current, {
      strings: [
        "What is Ebun heritage all about?",
        "Kí ni Ebun Heritage jẹ́ nípa? (Yoruba)",
        "Gịnị bụ Ebun Heritage gbasara? (Igbo)",
        "Menene Ebun Heritage yake game da shi? (Hausa)",
      ],
      typeSpeed: 50,
      backSpeed: 30,
      backDelay: 2000,
      loop: true,
      showCursor: true,
      cursorChar: "<span class='text-warning'>|</span>",
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <div>
      <Navbar />

      {/* HERO SECTION */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
        className="bg-white pt-lg-6 pt-4 pb-lg-6 pb-4 px-lg-6 px-4"
        style={{
          backgroundImage: "url('../../assets/images/background/school.svg')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "100% 100%",
          opacity: 0.95, // ✅ less visible background
        }}
      >
        <div className="container">
          <div className="row align-items-center py-lg-8 px-lg-0">
            <div className="col-lg-12 text-center">
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="fs-1 fw-semibold text-dark-blue"
              >
                <span ref={typedEl}></span>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.section>

      {/* MISSION + VISION + VALUES */}
      <section className="bg-white pt-lg-6 pt-4 pb-lg-8 pb-8 px-lg-6 px-4">
        <div className="container">
          <div className="row align-items-center py-lg-6 px-lg-0">

            {/* Mission */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6"
            >
              <div className="fs-t2 text-gray-800 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"
                  className="text-pastels-yellow" style={{ color: '#FFC501' }}>
                  <path d="M20 0s-.834 17.324-20 20c0 0 16.453.315 20 20 0 0 1.13-17.018 20-20 0 0-17.93-2.523-20-20Z"
                    fill="currentColor"></path></svg> {" "}
                Our <u className="text-primary"><span className="text-dark-blue"> Mission</span></u>
              </div>
              
              <div className={`"fs-4 text-dark" ${
              isMobile ? '' : '"text-justify"'
              }`}>
                    At Ebun Heritage Schools, our mission is to harness the God-given potentials in every child, nurturing their 
                    unique gifts and abilities while guiding them to discover a dream and a purpose that inspires excellence. 
                    We are committed to cultivating academic brilliance, moral integrity, and spiritual growth in a safe, supportive, 
                    and dynamic learning environment. <br/><br/>
                    Through innovative teaching, mentorship, and holistic education, we prepare our students to become confident, 
                    responsible, and globally minded leaders who will positively impact their communities and the world at large.
                    </div>

            </motion.div>

            {/* Vision */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mt-lg-0 mt-6"
            >
              <div className="fs-t2 text-gray-800 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"
                  className="text-pastels-yellow" style={{ color: '#38a169' }}>
                  <path d="M20 0s-.834 17.324-20 20c0 0 16.453.315 20 20 0 0 1.13-17.018 20-20 0 0-17.93-2.523-20-20Z"
                    fill="currentColor"></path></svg> {" "}
                Our <u className="text-primary"><span className="text-dark-blue"> Vision</span></u>
              </div>
              <div className={`"fs-4 text-dark" ${
              isMobile ? '' : '"text-justify"'
              }`}>
                    At Ebun Heritage Schools, our mission is to harness the God-given potentials in every child, nurturing their 
                    unique gifts and abilities while guiding them to discover a dream and a purpose that inspires excellence. 
                    We are committed to cultivating academic brilliance, moral integrity, and spiritual growth in a safe, supportive, 
                    and dynamic learning environment. <br/><br/>
                    Through innovative teaching, mentorship, and holistic education, we prepare our students to become confident, 
                    responsible, and globally minded leaders who will positively impact their communities and the world at large.
                    </div>
            </motion.div>

            {/* Corporate Value */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-12 mt-lg-8 mt-6"
            >
              <div className="fs-t2 text-gray-700 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"
                  className="text-pastels-yellow" style={{ color: '#754ffe' }}>
                  <path d="M20 0s-.834 17.324-20 20c0 0 16.453.315 20 20 0 0 1.13-17.018 20-20 0 0-17.93-2.523-20-20Z"
                    fill="currentColor"></path></svg> {" "}
                Our <u className="text-primary"><span className="text-dark-blue"> Corporate Value</span></u>
              </div>
              <div className={`"fs-4 text-dark" ${
              isMobile ? '' : '"text-justify"'
              }`}>
                    To mould lives and destinies and it requires the participation of all towards unending pursuit of excellence as we 
                    bring the benefits of our extra ordinary services to our customers. 
                    This way of doing business can be best expressed by our four core objectives which are;
                    <br/><br/>
                    - To honour God in all that we do<br/>
                    - To help these children develop and have a dream of a glorious future.<br/>
                    - To pursue academic execellence and be disciplined<br/>
                    - To grow profitably
                    </div>

            </motion.div>

          </div>
        </div>
      </section>

      {/* CONTACT CARD + HISTORY */}
      <section className="bg-back pt-lg-6 pt-8 pb-lg-6 pb-4 px-lg-6 px-0">
        <div className="container">

          {/* Contact Card */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="px-lg-18 mt-lg-n14 mt-n8"
          >
            <div className="card shadow-lg bg-dark-blue p-4 p-lg-6" style={{ borderRadius: '30px' }}>
              <div className="d-lg-flex text-center">
                <div className="text-end">
                  <div className="fs-5 text-white">Get In Touch:</div>
                  <div className="fs-3 text-white">admin@ebunheritageschool.com</div>
                </div>
                <div className="ms-4 me-4 mt-4 mb-4">
                  <button className="btn btn-white shadow-lg btn-icon fw-semibold py-4 px-4 fs-3 text-dangdar-blue rounded-circle">or</button>
                </div>
                <div className="text-lg-start">
                  <div className="fs-5 text-white">Call Us Via:</div>
                  <div className="fs-3 text-white">+234 703 414 6618</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* History */}
          <div className="row align-items-center pt-lg-10 pt-6 pb-lg-6 px-lg-0">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0"
            >
              <div className="fs-t2 text-gray-800 fw-semibold mb-lg-4 mb-4 text-lg-start text-center">
                <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"
                  className="text-pastels-yellow" style={{ color: '#38a169' }}>
                  <path d="M20 0s-.834 17.324-20 20c0 0 16.453.315 20 20 0 0 1.13-17.018 20-20 0 0-17.93-2.523-20-20Z"
                    fill="currentColor"></path></svg> {" "}
                Our <u className="text-primary"><span className="text-dark-blue">School History</span></u>
              </div>
              <div className={`"fs-4 text-dark" ${
              isMobile ? 'px-4' : '"text-justify"'
              }`}>
                        Ebun Heritage Foundation School was established in the year 2000 precisely September 25th with only seventeen children in the preschool section.
                        It got the approval of the Lagos Ministry of Education in 2006 to operate as a Nursery and Primary School.
                        Today, the school has grown a population of over 400 with 65 teaching and Non-teaching staff.
                        The school has an annex at 18, Imaam Saliu Street, Akesan. It has moved her secondary students to their site at 22 Tolu Aluko Street just beside the present address for the foundation school. Indeed the school is growing and expanding and this is attributed to the hand of the Almighty God upon her affairs, to the effort of the handworking staff and relenting and focused charisma of the proprietress of the school; as she goes on her quest for Moral and Academic Excellence.
                        To God be all the glory.
                        </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <div className="overflow-hidden border-0 position-relative">
                <img
                  src="../../assets/images/background/his.svg"
                  alt="Director"
                  width={500}
                  className="img-fluid mb-lg-4"
                />
                {/* Play button */}
                <a
                  className="glightbox btn-play position-absolute top-50 start-50 translate-middle
                    d-flex align-items-center justify-content-center ms-4"
                  href="https://youtu.be/gL5UkbjRX_Q"
                  data-type="video"
                  data-source="youtube"
                  style={{
                    width: "70px",
                    height: "70px",
                    background: "none",
                    clipPath:
                      "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                    color: "#fff",
                    fontSize: "2.5rem",
                    textAlign: "center",
                  }}
                >
                  <i className="fe fe-play"></i>
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <Core/>

      <Footer />
    </div>
  );
};

export default AboutUs;
